var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VBadge',_vm._b({class:`state state-${_vm.statusLowercase}`,attrs:{"label":_vm.label}},'VBadge',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }